import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Loading } from '@components/ui/loading/loading';
import { StatusTag } from '@components/ui/status-tag/status-tag';
import { DatabaseConnectionsSnapshot } from '@6grain/masofa-monolith-api-client/common/model/databaseConnectionsSnapshot';
import {
  slotPressureLabelKey,
  slotPressureTagColor,
  visibilityLabelKey,
  formatDatabaseSizeBytes,
  readDiskVolume,
} from '@app/pages/admin/orchestration-database-connections.util';

@Component({
  selector: 'app-orchestration-database-slot-board',
  standalone: true,
  imports: [DatePipe, TranslateModule, Loading, StatusTag],
  templateUrl: './orchestration-database-slot-board.html',
  styleUrl: './orchestration-database-slot-board.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrchestrationDatabaseSlotBoardComponent {
  readonly snapshot = input<DatabaseConnectionsSnapshot | null>(null);
  readonly errorMessage = input('');
  readonly loading = input(false);
  readonly heading = input('');
  readonly labelledBy = input('');

  readonly pressureColor = computed(() => slotPressureTagColor(this.snapshot()?.slotPressure));
  readonly pressureLabel = computed(() => slotPressureLabelKey(this.snapshot()?.slotPressure));
  readonly visibilityLabel = computed(() => visibilityLabelKey(this.snapshot()?.visibility));
  readonly ownSessionsOnly = computed(() => this.snapshot()?.visibility === 'OwnSessions');
  readonly boardLabelledBy = computed(() => this.labelledBy() || 'database-slot-board-title');
  readonly disk = computed(() => readDiskVolume(this.snapshot()));
  readonly diskAvailableLabel = computed(() => formatDatabaseSizeBytes(this.disk().availableBytes));
  readonly diskTotalLabel = computed(() => formatDatabaseSizeBytes(this.disk().totalBytes));
  readonly showDisk = computed(() => this.disk().availableBytes != null && this.disk().totalBytes != null);
}
